import { useQuery } from '@tanstack/react-query';
import { endUsersApi } from '../api/end-users.api';
import { endUserKeys } from './queryKeys';

export const useEndUserDetail = (userId: string | null) => {
  return useQuery({
    queryKey: endUserKeys.detail(userId!),
    queryFn: async () => {
      const response = await endUsersApi.getEndUserById(userId!);
      return response.data;
    },
    enabled: userId !== null,
    staleTime: 1000 * 60 * 2,
  });
};
